export const defaultOptions = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

export const colourData = [
  { value: "Albania", label: "Red" },
  { value: "Andorra", label: "Blue" },
  { value: "Australia", label: "Green" },
  { value: "India", label: "Yellow" },
  { value: "Italy", label: "White" },
];

export const types = [
  {
      "id": 1,
      "name": "Mobile Payments",
      "created_at": "2024-09-20T09:28:58.307000Z",
      "updated_at": "2024-09-20T09:28:58.307000Z",
      "service": 1
  },
  {
      "id": 2,
      "name": "E-wallet",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 3,
      "name": "Cards",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 5,
      "name": "Buy Now Pay Later",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 6,
      "name": "Bank Transfer",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 7,
      "name": "Cash Payment",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 8,
      "name": "Real-time Bank Transfer",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 9,
      "name": "Prepaid - Voucher - Giftcard",
      "created_at": null,
      "updated_at": null,
      "service": 1
  },
  {
      "id": 10,
      "name": "Online Banking",
      "created_at": null,
      "updated_at": null,
      "service": 1
  }
]

export const countrisData = [
    {
        "id": 1,
        "top_apm_providers": [
            {
                "id": 11,
                "name": "Alipay",
                "description": "Alipay is a widely used digital wallet and mobile payment platform originating from China. It enables users to conduct secure online and in-store transactions, transfer money, and manage financial activities directly through its app or website. Alipay supports a variety of services including bill payments, ride-hailing, and hotel bookings, making it a comprehensive financial solution for everyday needs.",
                "category": "E-wallet",
                "image": "http://192.168.18.241:8000/media/images/alipay_hjXtBFc.jpg",
                "created_at": "2024-09-23T07:41:52.219000Z",
                "updated_at": "2024-09-23T07:41:52.219000Z",
                "service": 1
            },
            {
                "id": 13,
                "name": "Apple Pay",
                "description": "Apple Pay is a mobile payment and digital wallet service by Apple Inc. It allows users to make payments in person, in iOS apps, and on the web using Safari. Secured with biometric authentication methods like Touch ID and Face ID, it provides a fast and secure way to make contactless payments using Apple devices.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/apple_pay_bhkP3XP.jpg",
                "created_at": "2024-09-23T07:49:49.692000Z",
                "updated_at": "2024-09-23T07:49:49.692000Z",
                "service": 1
            },
            {
                "id": 14,
                "name": "Klarna",
                "description": "Klarna is a Swedish fintech company offering flexible payment solutions for online shoppers. It provides options like pay later, pay in installments, and direct payments, giving customers the flexibility to choose a payment plan that suits their financial situation while shopping online.",
                "category": "Buy Now Pay Later",
                "image": "http://192.168.18.241:8000/media/images/klarna_H5d9LTU.jpg",
                "created_at": "2024-09-23T07:50:30.279000Z",
                "updated_at": "2024-09-23T07:50:30.279000Z",
                "service": 1
            }
        ],
        "name": "Albania",
        "image": "http://192.168.18.241:8000/media/country_images/download_3.png",
        "country_code": "ALL",
        "fatf_status": "Member of MONEYVAL (as of 2023)",
        "compliance": "Albania has made significant progress in improving its AML/CFT measures but continues to address remaining deficiencies.",
        "payment_and_banking_providers": "Raiffeisen Bank Albania,Banka Kombëtare Tregtare (BKT),Intesa Sanpaolo Bank Albania,Credins Bank,OTP Bank Albania,Alpha Bank Albania,Union Bank,Tirana Bank,ProCredit Bank,Fibank Albania",
        "payment_methods": [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8
        ]
    },
    {
        "id": 2,
        "top_apm_providers": [
            {
                "id": 11,
                "name": "Alipay",
                "description": "Alipay is a widely used digital wallet and mobile payment platform originating from China. It enables users to conduct secure online and in-store transactions, transfer money, and manage financial activities directly through its app or website. Alipay supports a variety of services including bill payments, ride-hailing, and hotel bookings, making it a comprehensive financial solution for everyday needs.",
                "category": "E-wallet",
                "image": "http://192.168.18.241:8000/media/images/alipay_hjXtBFc.jpg",
                "created_at": "2024-09-23T07:41:52.219000Z",
                "updated_at": "2024-09-23T07:41:52.219000Z",
                "service": 1
            },
            {
                "id": 12,
                "name": "Visa",
                "description": "Visa is a global payment technology company that facilitates electronic funds transfers worldwide. It offers consumers and businesses a range of payment products like credit, debit, and prepaid cards, enabling secure and convenient transactions both online and offline.",
                "category": "Cards",
                "image": "http://192.168.18.241:8000/media/images/visa_RLdzhbt.jpg",
                "created_at": "2024-09-23T07:49:03.089000Z",
                "updated_at": "2024-09-23T07:49:03.089000Z",
                "service": 1
            },
            {
                "id": 13,
                "name": "Apple Pay",
                "description": "Apple Pay is a mobile payment and digital wallet service by Apple Inc. It allows users to make payments in person, in iOS apps, and on the web using Safari. Secured with biometric authentication methods like Touch ID and Face ID, it provides a fast and secure way to make contactless payments using Apple devices.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/apple_pay_bhkP3XP.jpg",
                "created_at": "2024-09-23T07:49:49.692000Z",
                "updated_at": "2024-09-23T07:49:49.692000Z",
                "service": 1
            },
            {
                "id": 14,
                "name": "Klarna",
                "description": "Klarna is a Swedish fintech company offering flexible payment solutions for online shoppers. It provides options like pay later, pay in installments, and direct payments, giving customers the flexibility to choose a payment plan that suits their financial situation while shopping online.",
                "category": "Buy Now Pay Later",
                "image": "http://192.168.18.241:8000/media/images/klarna_H5d9LTU.jpg",
                "created_at": "2024-09-23T07:50:30.279000Z",
                "updated_at": "2024-09-23T07:50:30.279000Z",
                "service": 1
            },
            {
                "id": 15,
                "name": "WeChat Pay",
                "description": "WeChat Pay is a mobile payment feature integrated within the WeChat app, one of China's most popular messaging platforms. It allows users to perform a wide range of financial transactions, including peer-to-peer transfers, online shopping payments, and in-store purchases using QR codes, all within the app.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/wechat_pay_s4MTfpb.jpg",
                "created_at": "2024-09-23T07:51:20.210000Z",
                "updated_at": "2024-09-23T07:51:20.210000Z",
                "service": 1
            }
        ],
        "name": "Algeria",
        "image": "http://192.168.18.241:8000/media/country_images/download_2.png",
        "country_code": "DZD",
        "fatf_status": "Member of MENAFATF (as of 2023)",
        "compliance": "Algeria has taken steps to strengthen its AML/CFT regime but still faces challenges in implementation.",
        "payment_and_banking_providers": "Banque Extérieure d'Algérie,Banque Nationale d'Algérie,Crédit Populaire d'Algérie,Banque de l'Agriculture et du Développement Rural,Société Générale Algérie,Arab Banking Corporation (ABC) Algeria,Gulf Bank Algeria,BNP Paribas El Djazair,Citibank Algeria,HSBC Algeria",
        "payment_methods": [
            1,
            2,
            3,
            4,
            5,
            11
        ]
    },
    {
        "id": 3,
        "top_apm_providers": [
            {
                "id": 12,
                "name": "Visa",
                "description": "Visa is a global payment technology company that facilitates electronic funds transfers worldwide. It offers consumers and businesses a range of payment products like credit, debit, and prepaid cards, enabling secure and convenient transactions both online and offline.",
                "category": "Cards",
                "image": "http://192.168.18.241:8000/media/images/visa_RLdzhbt.jpg",
                "created_at": "2024-09-23T07:49:03.089000Z",
                "updated_at": "2024-09-23T07:49:03.089000Z",
                "service": 1
            },
            {
                "id": 13,
                "name": "Apple Pay",
                "description": "Apple Pay is a mobile payment and digital wallet service by Apple Inc. It allows users to make payments in person, in iOS apps, and on the web using Safari. Secured with biometric authentication methods like Touch ID and Face ID, it provides a fast and secure way to make contactless payments using Apple devices.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/apple_pay_bhkP3XP.jpg",
                "created_at": "2024-09-23T07:49:49.692000Z",
                "updated_at": "2024-09-23T07:49:49.692000Z",
                "service": 1
            },
            {
                "id": 14,
                "name": "Klarna",
                "description": "Klarna is a Swedish fintech company offering flexible payment solutions for online shoppers. It provides options like pay later, pay in installments, and direct payments, giving customers the flexibility to choose a payment plan that suits their financial situation while shopping online.",
                "category": "Buy Now Pay Later",
                "image": "http://192.168.18.241:8000/media/images/klarna_H5d9LTU.jpg",
                "created_at": "2024-09-23T07:50:30.279000Z",
                "updated_at": "2024-09-23T07:50:30.279000Z",
                "service": 1
            }
        ],
        "name": "Armenia",
        "image": "http://192.168.18.241:8000/media/country_images/download_1.png",
        "country_code": "AMD",
        "fatf_status": "Member of MONEYVAL (as of 2023)",
        "compliance": "Armenia has made progress but needs to address remaining deficiencies.",
        "payment_and_banking_providers": "Ameriabank,ACBA Bank,Ardshinbank,Armbusinessbank,Inecobank,Converse Bank,Unibank,VTB Bank Armenia,HSBC Armenia\",IDBank",
        "payment_methods": [
            1,
            2,
            3,
            4,
            5,
            7,
            10
        ]
    },
    {
        "id": 4,
        "top_apm_providers": [
            {
                "id": 13,
                "name": "Apple Pay",
                "description": "Apple Pay is a mobile payment and digital wallet service by Apple Inc. It allows users to make payments in person, in iOS apps, and on the web using Safari. Secured with biometric authentication methods like Touch ID and Face ID, it provides a fast and secure way to make contactless payments using Apple devices.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/apple_pay_bhkP3XP.jpg",
                "created_at": "2024-09-23T07:49:49.692000Z",
                "updated_at": "2024-09-23T07:49:49.692000Z",
                "service": 1
            },
            {
                "id": 14,
                "name": "Klarna",
                "description": "Klarna is a Swedish fintech company offering flexible payment solutions for online shoppers. It provides options like pay later, pay in installments, and direct payments, giving customers the flexibility to choose a payment plan that suits their financial situation while shopping online.",
                "category": "Buy Now Pay Later",
                "image": "http://192.168.18.241:8000/media/images/klarna_H5d9LTU.jpg",
                "created_at": "2024-09-23T07:50:30.279000Z",
                "updated_at": "2024-09-23T07:50:30.279000Z",
                "service": 1
            }
        ],
        "name": "Mexico",
        "image": "http://192.168.18.241:8000/media/country_images/download.png",
        "country_code": "MX",
        "fatf_status": "Member of FATF and GAFILAT (as of 2023)",
        "compliance": "Mexico has a robust AML/CFT framework but continues to address certain deficiencies.",
        "payment_and_banking_providers": "BBVA Bancomer,Banamex (Citibanamex),Banorte,Santander Mexico,HSBC Mexico,Scotiabank Inverlat,Banco Inbursa,Banco Azteca,Banco del Bajío,Banco Interacciones",
        "payment_methods": [
            1,
            2,
            3,
            4,
            10,
            12,
            13,
            21
        ]
    },
    {
        "id": 5,
        "top_apm_providers": [
            {
                "id": 11,
                "name": "Alipay",
                "description": "Alipay is a widely used digital wallet and mobile payment platform originating from China. It enables users to conduct secure online and in-store transactions, transfer money, and manage financial activities directly through its app or website. Alipay supports a variety of services including bill payments, ride-hailing, and hotel bookings, making it a comprehensive financial solution for everyday needs.",
                "category": "E-wallet",
                "image": "http://192.168.18.241:8000/media/images/alipay_hjXtBFc.jpg",
                "created_at": "2024-09-23T07:41:52.219000Z",
                "updated_at": "2024-09-23T07:41:52.219000Z",
                "service": 1
            },
            {
                "id": 12,
                "name": "Visa",
                "description": "Visa is a global payment technology company that facilitates electronic funds transfers worldwide. It offers consumers and businesses a range of payment products like credit, debit, and prepaid cards, enabling secure and convenient transactions both online and offline.",
                "category": "Cards",
                "image": "http://192.168.18.241:8000/media/images/visa_RLdzhbt.jpg",
                "created_at": "2024-09-23T07:49:03.089000Z",
                "updated_at": "2024-09-23T07:49:03.089000Z",
                "service": 1
            },
            {
                "id": 13,
                "name": "Apple Pay",
                "description": "Apple Pay is a mobile payment and digital wallet service by Apple Inc. It allows users to make payments in person, in iOS apps, and on the web using Safari. Secured with biometric authentication methods like Touch ID and Face ID, it provides a fast and secure way to make contactless payments using Apple devices.",
                "category": "Mobile Payments",
                "image": "http://192.168.18.241:8000/media/images/apple_pay_bhkP3XP.jpg",
                "created_at": "2024-09-23T07:49:49.692000Z",
                "updated_at": "2024-09-23T07:49:49.692000Z",
                "service": 1
            }
        ],
        "name": "United States",
        "image": "http://192.168.18.241:8000/media/country_images/download.jpeg",
        "country_code": "US",
        "fatf_status": "Member of FATF (as of 2023)",
        "compliance": "The United States has a strong AML/CFT framework and is largely compliant with FATF recommendations.",
        "payment_and_banking_providers": "JPMorgan Chase,Bank of America,Wells Fargo,Citibank,U.S. Bank,PNC Bank,Truist Financial,Capital One,TD Bank,Goldman Sachs",
        "payment_methods": [
            1,
            2,
            3,
            4,
            5,
            10,
            13
        ]
    }
]

export const groupedData = [
  {
    label: "Flavours",
    options: [
      { value: "chocolate", label: "Chocolate" },
      { value: "strawberry", label: "Strawberry" },
      { value: "vanilla", label: "Vanilla" },
    ],
  },
  {
    label: "Colors",
    options: [
      { value: "red", label: "Red" },
      { value: "blue", label: "Blue" },
      { value: "green", label: "Green" },
    ],
  },
  { label: "UnGrouped", value: "value_3" },
];
